// Global function to convert an amount to crores (Cr)
function convertToCr(amount) {
  // Ensure the input is a number
  const num = typeof amount === "number" ? amount : parseFloat(amount);

  // If the amount is below one crore, return it as is.
  if (num < 10000000) {
    return num.toString();
  }

  // Convert the amount to crores.
  // Here, we truncate to 2 decimal places (without rounding up).
  const crores = num / 10000000;
  const truncatedCrores = Math.floor(crores * 100) / 100;

  return truncatedCrores.toFixed(2) + " Cr";
}

export default convertToCr;
